var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevenueSupplier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.43,
    height: 42.184,
    viewBox: "0 0 62.43 42.184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5693",
    "data-name": "Group 5693",
    transform: "translate(-1061.668 -215.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6880",
    "data-name": "Path 6880",
    d: "M22.362,3.06V4.188a2.23,2.23,0,0,0,.8,1.716l2.121,1.767a2.237,2.237,0,0,1,.429,2.959L24.7,12.15A4.468,4.468,0,0,1,22.4,13.91l-.284.1a2.2,2.2,0,0,0-1.132,3.3,2.2,2.2,0,0,1-.848,3.187l-5.218,2.609.84,2.1a1.9,1.9,0,0,1-3.28,1.843l-1.348-1.8a2.234,2.234,0,0,0-3.785.342L5.981,28.317l-1.215.3m17.6-25.559a17.871,17.871,0,0,0-17.6,25.559m17.6-25.559a17.871,17.871,0,0,1,13.284,27.87m0,0-.351-1.05a4.468,4.468,0,0,0-4.239-3.054H29.809l-.643-.643a2.885,2.885,0,0,0-4.623.749l-.071.145a3.149,3.149,0,0,1-1.95,1.62l-1.966.56a2.233,2.233,0,0,0-1.589,2.516l.145.87a1.954,1.954,0,0,0,1.926,1.63,3.9,3.9,0,0,1,3.7,2.671l.427,1.277m10.476-7.287a17.894,17.894,0,0,1-10.476,7.287m0,0a17.871,17.871,0,0,1-20.4-9.6M28.319,14.914A5.943,5.943,0,0,1,26.3,19.382",
    transform: "translate(1084.418 212.839)",
    fill: "rgba(0,0,0,0)",
    stroke: "#f4f6f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3499",
    "data-name": "Rectangle 3499",
    width: 13,
    height: 32,
    transform: "translate(1086 221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6882",
    "data-name": "Path 6882",
    d: "M26.476,8.417m-9.029,0c0,2.992,4.042,5.417,9.029,5.417S35.5,11.409,35.5,8.417,31.462,3,26.476,3s-9.029,2.425-9.029,5.417v7.223c0,2.992,4.043,5.417,9.029,5.417S35.5,18.633,35.5,15.641V8.417M17.447,15.641v7.223c0,2.992,4.043,5.417,9.029,5.417S35.5,25.856,35.5,22.864V15.641M17.447,22.864v7.223c0,2.992,4.043,5.417,9.029,5.417S35.5,33.08,35.5,30.087V22.864M10.223,13.835H5.709a2.709,2.709,0,0,0,0,5.417H7.515a2.709,2.709,0,1,1,0,5.417H3m3.612,0v1.806m0-14.447v1.806",
    transform: "translate(1059.418 221)",
    fill: "none",
    stroke: "#dde4eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueSupplier);
export default __webpack_public_path__ + "static/media/revenue-supplier.aa4fe9e2.svg";
export { ForwardRef as ReactComponent };